'use strict';
module.exports = require('../../full/object/assign');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/assign.js
// module id = 604
// module chunks = 13